import React from 'react';
import { motion } from 'framer-motion';
const tasks = ['Search for drills', 'Write a lesson structure', 'Look for another progression', 'Try to remember a correction', 'Adapt something for a different level', 'Build a backup session'];
export function TimeSavings() {
  return <section className="py-24 px-4 bg-ivory" data-id="element-265" data-mp="15wzv7t17otsi">
      <div className="max-w-4xl mx-auto" data-id="element-266" data-mp="15w6w9e8hv8kx">
        <div className="text-center mb-10" data-id="element-267" data-mp="10x3r7tsil2cy">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-navy mb-4" data-id="element-268" data-mp="10yyc583scuh1">
            How Much Time Could This Save You?
          </h2>
          <p className="text-lg text-graphite" data-id="element-269" data-mp="r7k7yn0w36hk">
            Think about the number of lessons you teach every week. Now think about how often
            you:
          </p>
        </div>

        <ul className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3 mb-10" data-id="element-270" data-mp="n45otnhnm9zw">
          {tasks.map((task, index) => <motion.li key={task} initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.25,
          delay: index * 0.04,
          ease: [0.23, 1, 0.32, 1]
        }} className="bg-pearl-light border border-pearl-dark rounded-xl px-5 py-4 text-sm text-graphite" data-id="element-271" data-mp="d82o8m2gajf2" data-mpi={index}>
              {task}
            </motion.li>)}
        </ul>

        <div className="max-w-2xl mx-auto text-center" data-id="element-272" data-mp="vam83ut8muwe">
          <p className="text-graphite mb-6" data-id="element-273" data-mp="1j3ci3yhkz441">
            Even saving a small amount of preparation time per lesson can add up across an
            entire month — and that is before considering the mental benefit of arriving at
            the pool already knowing what you are going to teach.
          </p>
          <p className="text-2xl font-serif font-bold text-navy" data-id="element-274" data-mp="1e1wvw33o2rk2">
            Less searching. Less rebuilding. Less improvising.{' '}
            <span className="text-gold-dark" data-id="element-275" data-mp="3twfchntve0v8">More teaching.</span>
          </p>
        </div>
      </div>
    </section>;
}